/**
 * Может ли подключение senderId прислать реакцию от лица этого бота
 * (SEND_REACTION с fromPlayerId, проверка сервера).
 *
 * - Бот под ручным управлением админа (botControlledByUserId) говорит только
 *   голосом этого админа — из его панели реакций. Остальные клиенты за такого
 *   бота молчат (checkIfBotSendsReactions), и чужая реакция от его имени —
 *   подделка.
 * - Явный бот реакций не шлет никогда (см. checkIfBotSendsReactions).
 * - За обычного неявного бота реакции симулирует любой реальный клиент лобби
 *   (BotReactionsSimulator), поэтому отправитель не проверяется.
 *
 * @param {Object} bot - бот лобби вместе с его состоянием в матче
 * @param {string} senderId - id подключения, приславшего реакцию
 */
export const checkIfReactionOnBehalfOfBotAllowed = (bot, senderId) => {
  if (!bot || !bot.isBot || bot.isVisibleBot) {
    return false;
  }
  if (bot.botControlledByUserId) {
    return bot.botControlledByUserId === senderId;
  }
  return true;
};
